'use strict';
module.exports = function  googleMetadataToFileContext(metadata) {
	if (!metadata) {
		throw new Error('invalid-args');
	}

	const capabilities = metadata.capabilities || {},
		isRealtime = metadata.mimeType && metadata.mimeType.startsWith('application/vnd.google-apps.drive-sdk.'),
		isOwner = metadata.ownedByMe || metadata.teamDriveId,
		appProperties = metadata.appProperties || {},
		migrated = !!appProperties.migrated;

	return {
		title: metadata.name,
		fileId: metadata.id,
		checksum: metadata.md5Checksum,
		isShared: metadata.shared || !!metadata.teamDriveId,
		isOwner: isOwner,
		canShare: capabilities.canShare && !metadata.teamDriveId,
		canMove: !metadata.teamDriveId,
		canEdit: !isRealtime && capabilities.canEdit,
		modifiedBy: metadata.lastModifyingUser && metadata.lastModifyingUser.displayName,
		modifiedTime: metadata.modifiedTime,
		modifiedLocalTime: (metadata.modifiedTime && new Date(metadata.modifiedTime).toLocaleTimeString()) || '',
		properties: appProperties,
		isAutosaved: !!(appProperties && appProperties.autosave),
		hasHistory: isRealtime,
		isRealtime: isRealtime,
		isMigrated: migrated
	};
};
